import { FiArchive, FiSend, FiUploadCloud } from "react-icons/fi";
import { LuBuilding2, LuHandshake, LuUsers, LuLayoutDashboard, LuGitCompare, LuFileText, LuClipboardList, LuBellRing } from "react-icons/lu";
import { MdOutlineDashboard } from "react-icons/md";
import CommonSidebar from "../../app_components/CommonSidebar";
import routing from "../../routing";
import { Supplier_Reports } from "../../db_access/supplier_reports";
import { useEffect, useState } from "react";

const EngagementSideBar = () => {
  const [hasPending, setHasPending] = useState(false);
  useEffect(() => {
    Supplier_Reports.get_mine_sent()
      .then(res => res.json())
      .then(data => setHasPending(data.some(r => r.status === "Pending")))
      .catch(() => setHasPending(false));
  }, []);
  const user = JSON.parse(localStorage.getItem("user"));
  const is_collaborate_internal_enabled = () => user["is_collaborate_internal_enabled"] === 1;
  const is_collaborate_external_enabled = () => user["is_collaborate_external_enabled"] === 1;
  const is_collaborate_enabled = () => is_collaborate_external_enabled() || is_collaborate_internal_enabled();
  const is_company_admin = () => user["is_company_admin"] === 1;
  const tabs = [
    {
      label: "Supplier Directory",
      value: "supplier_directory",
      icon: LuBuilding2,
      subHeader: "Features",
      rootPath: routing.engagement.supplier_directory.root,
      path: routing.engagement.supplier_directory.dashboard,
      visibility: true,
      subTabs: [
        {
          label: "Dashboard",
          value: "dashboard",
          icon: LuLayoutDashboard,
          path: routing.engagement.supplier_directory.dashboard,
          visibility: true,
        },
        {
          label: "Submit Data",
          value: "submit_data",
          icon: FiUploadCloud,
          path: routing.engagement.supplier_directory.submit_data,
          visibility: false,
        },
        {
          label: "Comparison",
          value: "comparison",
          icon: LuGitCompare,
          path: routing.engagement.supplier_directory.comparison,
          visibility: true,
        },
        {
          label: "Reports",
          value: "reports",
          icon: LuFileText,
          path: routing.engagement.supplier_directory.reports,
          visibility: true,
        },
      ],
    },
    {
      label: "Client Directory",
      value: "client_directory",
      icon: FiSend,
      subHeader: "Features",
      rootPath: routing.engagement.client_directory.root,
      path: routing.engagement.client_directory.dashboard,
      visibility: true,
      subTabs: [
        {
          label: "Dashboard",
          value: "dashboard",
          icon: LuLayoutDashboard,
          path: routing.engagement.client_directory.dashboard,
          visibility: true,
        },
        {
          label: "Submit Data",
          value: "submit_data",
          icon: FiSend,
          path: routing.engagement.client_directory.submit_data,
          visibility: true,
        },
        {
          label: "My Submissions",
          value: "my_submissions",
          icon: LuClipboardList,
          path: routing.engagement.client_directory.my_submissions,
          visibility: true,
        },
        {
          label: "Comparison",
          value: "comparison",
          icon: LuGitCompare,
          path: routing.engagement.client_directory.comparison,
          visibility: true,
        },
        {
          label: "Reports",
          value: "reports",
          icon: LuFileText,
          path: routing.engagement.client_directory.reports,
          visibility: true,
        },
        {
          label: "Pending Responses",
          value: "pending_responses",
          icon: LuBellRing,
          path: routing.engagement.client_directory.pending_responses,
          visibility: hasPending, // Only visible when there are pending responses
        },
      ],
    },
    {
      label: "B2B Directory",
      value: "partnership",
      icon: LuHandshake,
      rootPath: routing.engagement.b2b_directory.root,
      path: routing.engagement.b2b_directory.dashboard,
      visibility: true,
    },
    {
      label: "Collaborate",
      value: "collaborate",
      icon: LuUsers,
      subHeader: "Features",
      rootPath: routing.engagement.collaborate.root,
      path: routing.engagement.collaborate.dashboard,
      visibility: is_collaborate_enabled,
      subTabs: [
        {
          label: "Dashboard",
          value: "dashboard",
          icon: MdOutlineDashboard,
          path: routing.engagement.collaborate.dashboard,
          visibility: true,
        },
        {
          label: "My space",
          value: "my_space",
          icon: FiArchive,
          path: routing.engagement.collaborate.my_space,
          visibility: true,
        },
        {
          label: "Partnership",
          value: "partnership",
          icon: LuHandshake,
          path: routing.engagement.collaborate.partnership,
          visibility: true,
        },
        {
          label: "Internal",
          value: "internal",
          icon: FiArchive,
          path: routing.engagement.collaborate.internal,
          visibility: true,
        },
        {
          label: "External",
          value: "external",
          icon: FiArchive,
          path: routing.engagement.collaborate.external,
          visibility: is_company_admin,
        },
        {
          label: "History",
          value: "history",
          icon: FiArchive,
          path: routing.engagement.collaborate.history,
          visibility: true,
        },
      ],
    },
  ];

  return <CommonSidebar tabs={tabs} />;
};

export default EngagementSideBar;
